import { isEmpty } from 'lodash';

import { PricingValueApiInterface } from '@/types/api-types';

import { getTotalRate } from '../get-total-rate';
import { SpotRateModel } from '../types';

export const getAverageRate = (rates: SpotRateModel[]): PricingValueApiInterface | undefined => {
  if (isEmpty(rates)) return undefined;

  const rateSum = rates.reduce((accum, rate) => {
    const totalRate = getTotalRate(rate);
    return accum + totalRate.value;
  }, 0);

  return {
    value: Math.round(rateSum / rates.length),
    currency: rates[0].pricing.currency,
  };
};
